import api from '../config/api';

export const authService = {
  initProfile:      ()       => api.post('/api/user/secure/v1/profile').then(r => r.data),
  getProfile:       ()       => api.get('/api/user/secure/v1/profile').then(r => r.data),
  getProfileByUid:  (uid)    => api.get(`/api/user/secure/v1/profile/${uid}`).then(r => r.data),
  updateProfile:    (data)   => api.patch('/api/user/secure/v1/profile', data, {
    headers: { 'Content-Type': 'application/json' },
  }).then(r => r.data),
};

export const familyService = {
  createFamily:     ()               => api.post('/api/family/secure/v1/families').then(r => r.data),
  getFamily: async () => {
    const r = await api.get('/api/family/secure/v1/families');
    if (r.status === 205) {
      // 205 = JWT lacks familyId claim (stale token). Signal to the caller
      // to trigger reauthWithRedirect() so beforeSignIn can enrich a fresh JWT.
      throw Object.assign(new Error('Stale JWT — re-authentication required'), { code: 'STALE_TOKEN' });
    }
    return r.data;
  },
  leaveFamily:      ()               => api.post('/api/family/secure/v1/families:leave').then(r => r.data),
  listInvitations:  ()               => api.get('/api/family/secure/v1/families/invitations').then(r => r.data),
  sendInvitation:   (payload)        => api.post('/api/family/secure/v1/families/invitations', payload).then(r => r.data),
  acceptInvitation: (invitationId)   => api.post(`/api/family/secure/v1/families/invitations/${invitationId}:accept`).then(r => r.data),
  rejectInvitation: (invitationId)   => api.post(`/api/family/secure/v1/families/invitations/${invitationId}:reject`).then(r => r.data),
  removeMember:     (userId)         => api.delete(`/api/family/secure/v1/families/members/${userId}`).then(r => r.data),
  updateMemberRole: (userId, role)   => api.patch(`/api/family/secure/v1/families/members/${userId}/role`, { role }).then(r => r.data),
};

export const enrollmentService = {
  getEnrollments: () => api.get('/api/user/v1/enrollments').then(r => r.data.enrollments || []),
  getCamps: async () => {
    const list = await enrollmentService.getEnrollments();
    return list.filter(e => e.course_type === 'camp');
  },
  getCoachingCourses: async () => {
    const list = await enrollmentService.getEnrollments();
    return list.filter(e => e.course_type === 'coaching_course');
  },
};

export const documentsService = {
  getDocuments: (campId, participantId) =>
    api.get(`/api/user/v1/documents/${campId}${participantId ? `?participant_id=${participantId}` : ''}`).then(r => r.data),
  updateDocument: (campId, payload) =>
    api.patch(`/api/user/v1/documents/${campId}`, payload).then(r => r.data),
};

export const courseService = {
  getCourseDetail: (courseId) =>
    api.get(`/api/user/v1/courses/${courseId}`).then(r => r.data),
};

export const bootcampService = {
  getBootcamps:        ()                           => api.get('/api/course/secure/v1/bootcamps').then(r => r.data),
  assignBootcamp:      (enrollmentId, childEmail, gcpUid) => api.post(`/api/course/secure/v1/bootcamps/${enrollmentId}:assign`, { target_child_email: childEmail, gcp_identity_uid: gcpUid }).then(r => r.data),
  submitDocument:      (enrollmentId, payload)     => api.patch(`/api/course/secure/v1/bootcamps/${enrollmentId}/document:submit`, payload).then(r => r.data),
  getDocumentHistory:  (enrollmentId)              => api.get(`/api/course/secure/v1/bootcamps/${enrollmentId}/documents/history`).then(r => r.data),
  getDocumentVersion:  (enrollmentId, version)     => api.get(`/api/course/secure/v1/bootcamps/${enrollmentId}/documents/history/${version}`).then(r => r.data),
};
